import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import Select from "react-select";
import { useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import VideoListDropdown from "./quizSystem/videoSection/components/VideoListDropdown";
import DraggableSelectList from "./quizSystem/questionsSection/components/QuestionListDropdown";
import { Box, Button, Typography, styled } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { fetchActiveVideos } from "../store/reducers/videoSectionSlice";
import OnlyQuizListDropdown from "./quizSystem/onlyQuizSection/components/OnlyQuizListDropdown";
import { fetchQuizList } from "../store/reducers/onlyQuizSectionSlice";

const CircleContainer = styled("div")({
  width: 150,
  height: 150,
  borderRadius: "50%",
  border: "2px dashed #ccc",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  color: "#555",
  fontSize: "14px",
  cursor: "pointer",
  position: "relative",
  backgroundColor: "#f9f9f9",
  overflow: "hidden",
});

const ImagePreview = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "50%",
  position: "absolute",
  top: 0,
  left: 0,
});

const moduleOptions = [
  "scoreboard",
  "leader_board",
  "employee_performance",
  "employee_details",
  "badges",
];

const sectionUpdateButtonSx = {
  minWidth: 120,
  alignSelf: "flex-start",
};

const AddOrganisation = () => {
  const history = useHistory();
  const [action, setAction] = useState([]);
  const [select, setSelect] = useState(action[0]);
  const [selectedModules, setSelectedModules] = useState(moduleOptions);
  const { search } = useLocation();
  const paramIdSeprator = (param) => {
    const paramId = param.split("=");
    return paramId[1];
  };

  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
  });

  const validateForm = () => {
    const errors = { name: "", email: "" };
    let isValid = true;

    if (!organisation.name?.trim()) {
      errors.name = "Organisation name is required";
      isValid = false;
    }

    if (!organisation.email?.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(organisation.email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const getTodayDateString = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const [organisation, setOrganisation] = useState({
    name: "",
    vat: "",
    email: "",
    country: "",
    form: "",
    additional_street_info: "",
    city: "",
    state: "",
    postcode: "",
    remarks: "",
    show_reporting_category: false,
    street_address: "",
    unit: "",
    customer_id: 0,
    // New points fields
    selectedDate: getTodayDateString(),
    points_for_reading_ac: 1,
    points_for_mt: 20,
    no_badge_min: 0,
    no_badge_max: 2,
    bronze_min: 3,
    bronze_max: 29,
    silver_min: 30,
    silver_max: 49,
    gold_min: 50,
    gold_max: 99,
    platinum_min: 100,
    platinum_max: 149,
    diamond_min: 150,
    diamond_max: null,
    bronze_reading_max: 4,
    silver_reading_max: 4,
    gold_reading_max: 2,
    platinum_reading_max: 2,
    diamond_reading_max: 2,
    bronze_min_for_mt: 6,
    silver_min_for_mt: 6,
    gold_min_for_mt: 4,
    platinum_min_for_mt: 3,
    diamond_min_for_mt: 2,
    decrease_per_week: 5,
    length_decease_period: 7,
    decease_ptc_due_to_inactivity: 20,
    length_inactivity_periode: 30,
    decrease_in_pct_if_mt_requirements_not_met: 50,
    evaluation_time: 28,
    is_platinum: true,
    is_diamond: true,

    // Color and log configuration
    color: "",
    font_color: "",
    logo: "",
    view_ac_online: false,
    view_employee_pdfs: false,

    // Video view and quiz configuration
    view_educational_videos: false,
    delay_videos_quiz: 4,
    videos_questions_per_quiz: 3,
    expire_videos_quiz: 3,
    videos_points_awarded: 4,
    video_ids: [],

    // Read ac Quiz configuration
    view_cards_quiz: false,
    delay_cards_quiz: 4,
    expire_cards_quiz: 3,
    cards_questions_per_quiz: 3,
    cards_points_awarded: 4,

    // Quiz configuration
    view_quiz: false,
    quiz_points_awarded: 4,
    questions_per_quiz: 3,
    reappear_after_hours: 4,
    quiz_ids: [],
  });

  const jwtToken = localStorage.getItem("jwt_token");

  // Logo preview state
  const [logoPreview, setLogoPreview] = useState("");

  // Config visibility states
  const [showVideoConfig, setShowVideoConfig] = useState(false);
  const [showCardsConfig, setShowCardsConfig] = useState(false);
  const [showQuizConfig, setShowQuizConfig] = useState(false);

  // Default selected IDs for dropdowns (edit mode)
  const [defaultVideoIds, setDefaultVideoIds] = useState([]);
  const [defaultQuestionIds, setDefaultQuestionIds] = useState([]);

  const { activeVideos } = useSelector((state) => state.eduVideos);
  const { quizzesList } = useSelector((state) => state.onlyQuiz);
  const dispatch = useDispatch();

  const addOrg = async () => {
    let url = `${process.env.REACT_APP_API_URL}/organisations`;
    const body = getOrganisationPayload();

    fetch(url, {
      method: "post",
      body: JSON.stringify(body),
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          toast.error(data.error);
        } else {
          toast.success("Data Added");
          ClearData();
          history.push("/manage-organisations");
        }
      });
  };

  const onChangeHandler = (e) => {
    const { id, value, type, checked } = e.target;

    let newValue = value;

    if (type === "number") {
      newValue = value === "" ? "" : Number(value);
    } else if (type === "checkbox") {
      newValue = checked;
    }

    setOrganisation((prev) => ({
      ...prev,
      [id]: newValue,
    }));
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setShowVideoConfig(checked);
    setOrganisation((prev) => ({
      ...prev,
      view_educational_videos: checked,
    }));
  };

  const handleCardsCheckboxChange = (e) => {
    const checked = e.target.checked;
    setShowCardsConfig(checked);
    setOrganisation((prev) => ({
      ...prev,
      view_cards_quiz: checked,
    }));
  };

  const handleQuizCheckboxChange = (e) => {
    const checked = e.target.checked;
    setShowQuizConfig(checked);
    setOrganisation((prev) => ({
      ...prev,
      view_quiz: checked,
    }));
  };

  const handleSelectedIds = (ids) => {
    setOrganisation((prev) => ({
      ...prev,
      video_ids: ids,
    }));
  };

  const handleQuizSelectedIds = (ids) => {
    setOrganisation((prev) => ({
      ...prev,
      quiz_ids: ids,
    }));
  };

  // Logo handlers
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64 = event.target.result;
        setOrganisation((prev) => ({ ...prev, logo: base64 }));
        setLogoPreview(base64);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setOrganisation((prev) => ({ ...prev, logo: "" }));
    setLogoPreview("");
    const input = document.getElementById("upload-image");
    if (input) input.value = "";
  };

  const getOrganisationPayload = () => ({
    name: organisation.name,
    vat: organisation.vat,
    email: organisation.email,
    form: organisation.form,
    country: organisation.country,
    street_address: organisation.street_address,
    additional_street_info: organisation.additional_street_info,
    city: organisation.city,
    state: organisation.state,
    postcode: organisation.postcode,
    remarks: organisation.remarks,
    show_reporting_category: organisation.show_reporting_category,
    customer_id: organisation.customer_id,
    selectedDate: organisation.selectedDate,
    points_for_reading_ac: organisation.points_for_reading_ac,
    points_for_mt: organisation.points_for_mt,
    no_badge_min: organisation.no_badge_min,
    no_badge_max: organisation.no_badge_max,
    bronze_min: organisation.bronze_min,
    bronze_max: organisation.bronze_max,
    silver_min: organisation.silver_min,
    silver_max: organisation.silver_max,
    gold_min: organisation.gold_min,
    gold_max: organisation.gold_max,
    platinum_min: organisation.platinum_min,
    platinum_max: organisation.platinum_max,
    diamond_min: organisation.diamond_min,
    diamond_max: organisation.diamond_max,
    bronze_reading_max: organisation.bronze_reading_max,
    silver_reading_max: organisation.silver_reading_max,
    gold_reading_max: organisation.gold_reading_max,
    platinum_reading_max: organisation.platinum_reading_max,
    diamond_reading_max: organisation.diamond_reading_max,
    bronze_min_for_mt: organisation.bronze_min_for_mt,
    silver_min_for_mt: organisation.silver_min_for_mt,
    gold_min_for_mt: organisation.gold_min_for_mt,
    platinum_min_for_mt: organisation.platinum_min_for_mt,
    diamond_min_for_mt: organisation.diamond_min_for_mt,
    decrease_per_week: organisation.decrease_per_week,
    length_decease_period: organisation.length_decease_period,
    decease_ptc_due_to_inactivity: organisation.decease_ptc_due_to_inactivity,
    length_inactivity_periode: organisation.length_inactivity_periode,
    decrease_in_pct_if_mt_requirements_not_met:
      organisation.decrease_in_pct_if_mt_requirements_not_met,
    evaluation_time: organisation.evaluation_time,
    is_platinum: organisation.is_platinum,
    is_diamond: organisation.is_diamond,
    reward_permission: selectedModules,
    color: organisation.color,
    font_color: organisation.font_color,
    logo: organisation.logo,
    view_ac_online: organisation.view_ac_online,
    view_employee_pdfs: organisation.view_employee_pdfs,
    view_educational_videos: organisation.view_educational_videos,
    delay_videos_quiz: organisation.delay_videos_quiz,
    expire_videos_quiz: organisation.expire_videos_quiz,
    videos_questions_per_quiz: organisation.videos_questions_per_quiz,
    videos_points_awarded: organisation.videos_points_awarded,
    video_ids: organisation.video_ids,
    view_cards_quiz: organisation.view_cards_quiz,
    delay_cards_quiz: organisation.delay_cards_quiz,
    expire_cards_quiz: organisation.expire_cards_quiz,
    cards_questions_per_quiz: organisation.cards_questions_per_quiz,
    cards_points_awarded: organisation.cards_points_awarded,
    view_quiz: organisation.view_quiz,
    quiz_points_awarded: organisation.quiz_points_awarded,
    questions_per_quiz: organisation.questions_per_quiz,
    reappear_after_hours: organisation.reappear_after_hours,
    quiz_ids: organisation.quiz_ids,
  });

  const submitOrganisationUpdate = ({ redirectAfterSuccess = false } = {}) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields correctly");
      return;
    }

    const id = paramIdSeprator(search);
    if (!id) {
      addOrg();
      return;
    }

    let url = `${process.env.REACT_APP_API_URL}/organisations/${id}`;
    const body = getOrganisationPayload();

    fetch(url, {
      method: "post",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data;
        if (codeMessage.error) {
          toast.error(codeMessage.error);
        } else {
          toast.success("Data Updated");
          if (redirectAfterSuccess) {
            history.push("/manage-organisations");
          }
        }
      });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (search) {
      submitOrganisationUpdate({ redirectAfterSuccess: true });
    } else {
      addOrg();
    }
  };

  const renderSectionUpdateButton = () => {
    if (!search) return null;

    return (
      <Box mt={2}>
        <Button
          type="button"
          variant="contained"
          className="bg_color"
          sx={sectionUpdateButtonSx}
          onClick={() => submitOrganisationUpdate()}
        >
          Update
        </Button>
      </Box>
    );
  };

  const ClearData = () => {
    setOrganisation({
      name: "",
      vat: "",
      email: "",
      country: "",
      form: "",
      additional_street_info: "",
      city: "",
      state: "",
      postcode: "",
      remarks: "",
      show_reporting_category: false,
      address: "",
      unit: "",
      customer_id: "",
      // Reset points fields to defaults
      selectedDate: "",
      points_for_reading_ac: 1,
      points_for_mt: 20,
      no_badge_min: 0,
      no_badge_max: 2,
      bronze_min: 3,
      bronze_max: 30,
      silver_min: 31,
      silver_max: 50,
      gold_min: 51,
      gold_max: 100,
      platinum_min: 101,
      platinum_max: 201,
      diamond_min: 201,
      diamond_max: null,
      bronze_reading_max: 4,
      silver_reading_max: 4,
      gold_reading_max: 4,
      platinum_reading_max: 4,
      diamond_reading_max: 4,
      bronze_min_for_mt: 6,
      silver_min_for_mt: 6,
      gold_min_for_mt: 4,
      platinum_min_for_mt: 3,
      diamond_min_for_mt: 2,
      decrease_per_week: 5,
      length_decease_period: 7,
      decease_ptc_due_to_inactivity: 20,
      length_inactivity_periode: 30,
      decrease_in_pct_if_mt_requirements_not_met: 50,
      evaluation_time: 28,
      is_diamond: true,
      is_platinum: true,

      // Color and log configuration
      color: "",
      font_color: "",
      logo: "",
      view_ac_online: false,
      view_employee_pdfs: false,
      // Video Configuration

      view_educational_videos: false,
      delay_videos_quiz: 4,
      videos_questions_per_quiz: 3,
      expire_videos_quiz: 3,
      videos_points_awarded: 4,
      video_ids: [],

      // Read ac Quiz configuration
      view_cards_quiz: false,
      delay_cards_quiz: 4,
      expire_cards_quiz: 3,
      cards_questions_per_quiz: 3,
      cards_points_awarded: 4,

      // Quiz configuration
      view_quiz: false,
      quiz_points_awarded: 4,
      questions_per_quiz: 3,
      reappear_after_hours: 4,
      quiz_ids: [],
    });

    setSelectedModules([]);
    setLogoPreview("");
    setShowVideoConfig(false);
    setShowCardsConfig(false);
    setShowQuizConfig(false);
    setDefaultVideoIds([]);
    setDefaultQuestionIds([]);
  };

  const update = async (id, dropDownOptions) => {
    let url = `${process.env.REACT_APP_API_URL}/organisations/${id}`;
    fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.organizations;
        const points = data.data.organizations.points || {};

        setOrganisation({
          name: codeMessage.name,
          vat: codeMessage.vat,
          email: codeMessage.email,
          country: codeMessage.country,
          form: codeMessage.form,
          additional_street_info: codeMessage.additional_street_info,
          city: codeMessage.city,
          state: codeMessage.state,
          postcode: codeMessage.postcode,
          remarks: codeMessage.remarks,
          show_reporting_category: codeMessage.show_reporting_category ?? false,
          street_address: codeMessage.street_address,
          customer_id: codeMessage.customer_id,

          // Points section — safely fallback to default values
          selectedDate: points.selected_date ?? getTodayDateString(),
          points_for_reading_ac: points.points_for_reading_ac ?? 1,
          points_for_mt: points.points_for_mt ?? 20,
          no_badge_min: points.no_badge_min ?? 0,
          no_badge_max: points.no_badge_max ?? 2,
          bronze_min: points.bronze_min ?? 3,
          bronze_max: points.bronze_max ?? 29,
          silver_min: points.silver_min ?? 30,
          silver_max: points.silver_max ?? 49,
          gold_min: points.gold_min ?? 50,
          gold_max: points.gold_max ?? 99,
          platinum_min: points.platinum_min ?? 100,
          platinum_max: points.platinum_max ?? 149,
          diamond_min: points.diamond_min ?? 150,
          diamond_max: points.diamond_max ?? null,
          bronze_reading_max: points.bronze_reading_max ?? 4,
          silver_reading_max: points.silver_reading_max ?? 4,
          gold_reading_max: points.gold_reading_max ?? 2,
          platinum_reading_max: points.platinum_reading_max ?? 2,
          diamond_reading_max: points.diamond_reading_max ?? 2,
          bronze_min_for_mt: points.bronze_min_for_mt ?? 6,
          silver_min_for_mt: points.silver_min_for_mt ?? 6,
          gold_min_for_mt: points.gold_min_for_mt ?? 4,
          platinum_min_for_mt: points.platinum_min_for_mt ?? 3,
          diamond_min_for_mt: points.diamond_min_for_mt ?? 2,
          decrease_per_week: points.decrease_per_week ?? 5,
          length_decease_period: points.length_decease_period ?? 7,
          decease_ptc_due_to_inactivity:
            points.decease_ptc_due_to_inactivity ?? 20,
          length_inactivity_periode: points.length_inactivity_periode ?? 30,
          decrease_in_pct_if_mt_requirements_not_met:
            points.decrease_in_pct_if_mt_requirements_not_met ?? 50,
          evaluation_time: points.evaluation_time ?? 28,
          is_platinum: points.is_platinum ?? true,
          is_diamond: points.is_diamond ?? true,

          // Logo & color (now populated from response)
          logo: codeMessage.logo || "",
          color: codeMessage.color || "",
          font_color: codeMessage.font_color || "",

          view_ac_online: codeMessage.view_ac_online ?? false,
          view_employee_pdfs: codeMessage.view_employee_pdfs ?? false,

          // Video config (existing)
          view_educational_videos: codeMessage.view_educational_videos ?? false,
          delay_videos_quiz: codeMessage.delay_videos_quiz ?? 4,
          videos_questions_per_quiz: codeMessage.videos_questions_per_quiz ?? 3,
          expire_videos_quiz: codeMessage.expire_videos_quiz ?? 3,
          videos_points_awarded: codeMessage.videos_points_awarded ?? 4,
          video_ids: codeMessage.video_ids || [],

          // Cards & Quiz config (now populated based on keys for edit mode)
          view_cards_quiz: codeMessage.view_cards_quiz ?? false,
          delay_cards_quiz: codeMessage.delay_cards_quiz ?? 4,
          expire_cards_quiz: codeMessage.expire_cards_quiz ?? 3,
          cards_questions_per_quiz: codeMessage.cards_questions_per_quiz ?? 3,
          cards_points_awarded: codeMessage.cards_points_awarded ?? 4,

          view_quiz: codeMessage.view_quiz ?? false,
          quiz_points_awarded: codeMessage.quiz_points_awarded ?? 4,
          questions_per_quiz: codeMessage.questions_per_quiz ?? 3,
          reappear_after_hours: codeMessage.reappear_after_hours ?? 4,
          quiz_ids: codeMessage.quiz_ids || [],
        });

        setSelectedModules(points.reward_permission || moduleOptions);

        // Sync UI states for edit mode
        setLogoPreview(codeMessage.logo || "");
        setShowVideoConfig(codeMessage?.view_educational_videos ?? false);
        setShowCardsConfig(codeMessage?.view_cards_quiz ?? false);
        setShowQuizConfig(codeMessage?.view_quiz ?? false);
        setDefaultVideoIds(codeMessage?.video_ids || []);
        setDefaultQuestionIds(codeMessage.quiz_ids || []);

        const selectedPerson = dropDownOptions.filter(
          (one) => one.id === codeMessage.people_id,
        );
        setSelect(selectedPerson);
      });
  };

  const DataPerson = async () => {
    let url = `${process.env.REACT_APP_API_URL}/people`;
    const res = await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.people_details;
        if (codeMessage) {
          codeMessage.map((one) => {
            (one.value = one.id), (one.label = one.first_name);
          });
          setAction(codeMessage);
          return codeMessage;
        }
      });
    return res;
  };

  const [videoOptions, setVideoOptions] = useState([]);
  const [quizzesOptions, setQuizzesOptions] = useState([]);

  useEffect(() => {
    dispatch(fetchActiveVideos());
    dispatch(fetchQuizList());
  }, [dispatch]);

  useEffect(() => {
    if (activeVideos) {
      const formatted = activeVideos.map((q) => ({
        label: q.name,
        value: q.id,
      }));

      setVideoOptions(formatted);
    }
    if (quizzesList) {
      const formatted = quizzesList.map((q) => ({
        label: q.name,
        value: q.id,
      }));

      setQuizzesOptions(formatted);
    }
  }, [activeVideos, quizzesList]);

  useEffect(() => {
    const init = async () => {
      const dropDownOptions = await DataPerson();
      const id = paramIdSeprator(search);
      if (id) {
        update(id, dropDownOptions);
      }
    };
    init(); // call the async function
  }, []);

  const imagePreviewUrl = ""; // kept for reference but not used anymore

  return (
    <>
      <div style={{ height: "100vh", overflow: "auto" }}>
        <div className="row">
          <div className="col-12 mb-3">
            <h4>{paramIdSeprator(search) ? "Update" : "Add"} Organisation</h4>
          </div>
        </div>

        <form onSubmit={onSubmitHandler}>
          {/* Section 1: Organisation Details */}
          <div className="row mb-4">
            <div className="col-12">
              <h5>Organisation Details</h5>
            </div>

            <Box
              mt={2}
              mb={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Logo:
              </Typography>
              <input
                accept="image/png, image/jpeg, image/jpg, image/webp, image/heic, image/heif"
                type="file"
                id="upload-image"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <label
                htmlFor="upload-image"
                style={{ position: "relative", display: "inline-block" }}
              >
                <CircleContainer>
                  {logoPreview ? (
                    <ImagePreview src={logoPreview} alt="Logo Preview" />
                  ) : (
                    <span>Upload Logo.</span>
                  )}
                </CircleContainer>

                {logoPreview && (
                  <Button
                    onClick={handleRemoveImage}
                    sx={{
                      minWidth: "unset",
                      padding: 0,
                      position: "absolute",
                      top: "10px",
                      right: "-10px",
                      backgroundColor: "#f44336",
                      color: "#fff",
                      borderRadius: "50%",
                      width: 28,
                      height: 28,
                      "&:hover": {
                        backgroundColor: "#d32f2f",
                      },
                    }}
                  >
                    <RxCross2 size={16} />
                  </Button>
                )}
              </label>
            </Box>

            <div className="col-md-6 mb-2">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                className="form-control"
                id="name"
                value={organisation.name}
                onChange={onChangeHandler}
              />
              {formErrors.name && (
                <div style={{ fontSize: "12px", color: "red" }}>
                  {formErrors.name}
                </div>
              )}
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="vat">VAT:</label>
              <input
                type="number"
                className="form-control"
                id="vat"
                value={organisation.vat}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={organisation.email}
                onChange={onChangeHandler}
              />
              {formErrors.email && (
                <div style={{ fontSize: "12px", color: "red" }}>
                  {formErrors.email}
                </div>
              )}
            </div>
            {/* <label className="mt-1">
              Contact person:
            </label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              value={action ? select : []}
              name="color"
              options={action ? action : []}
              onChange={setSelect}
            /> */}
            <div className="col-md-6 mb-2">
              <label htmlFor="country">Country:</label>
              <input
                type="text"
                className="form-control"
                id="country"
                value={organisation.country}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="street_address">Street Address:</label>
              <input
                type="text"
                className="form-control"
                id="street_address"
                value={organisation.street_address}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="additional_street_info">
                Additional Street Info:
              </label>
              <input
                type="text"
                className="form-control"
                id="additional_street_info"
                value={organisation.additional_street_info}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="city">City:</label>
              <input
                type="text"
                className="form-control"
                id="city"
                value={organisation.city}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="state">State:</label>
              <input
                type="text"
                className="form-control"
                id="state"
                value={organisation.state}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="postcode">Postcode:</label>
              <input
                type="number"
                className="form-control"
                id="postcode"
                value={organisation.postcode}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label htmlFor="form">Form:</label>
              <input
                type="text"
                className="form-control"
                id="form"
                value={organisation.form}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-12 mb-2">
              <label htmlFor="remarks">Remarks:</label>
              <textarea
                className="form-control"
                id="remarks"
                value={organisation.remarks}
                onChange={onChangeHandler}
              />
            </div>
            <div className="col-md-4 mb-2 d-flex align-items-center mt-2">
              <input
                type="checkbox"
                id="show_reporting_category"
                checked={organisation.show_reporting_category}
                onChange={onChangeHandler}
              />
              <label className="ms-2 mt-1">Show Reporting Category</label>
            </div>
            <div className="col-12 mb-3">{renderSectionUpdateButton()}</div>

            <hr style={{ color: "red" }} />
            <div className="row mb-3">
              <div className="col-12">
                <h5>Brand Colors</h5>
              </div>
            </div>

            {[
              {
                id: "color",
                label: "Background color",
                placeholder: "#000000",
                fallback: "#000000",
                defaultValue: "#f6615f",
              },
              {
                id: "font_color",
                label: "Font color",
                placeholder: "#ffffff",
                fallback: "#ffffff",
                defaultValue: "#fff",
              },
            ].map(({ id, label, placeholder, fallback, defaultValue }) => (
              <div className="row mb-2 align-items-center" key={id}>
                <div className="col-2">
                  <label className="form-label mb-0">{label}</label>
                </div>

                {/* Color Picker */}
                <div className="col-1">
                  <input
                    type="color"
                    id={id}
                    className="form-control form-control-color w-100"
                    value={organisation[id] || fallback}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* Hex Input */}
                <div className="col-2">
                  <input
                    type="text"
                    id={id}
                    className="form-control"
                    placeholder={placeholder}
                    value={organisation[id] || ""}
                    onChange={(e) => {
                      let value = e.target.value;

                      if (value && !value.startsWith("#")) {
                        value = "#" + value;
                      }

                      if (value === "" || /^#([0-9A-Fa-f]{0,6})$/.test(value)) {
                        setOrganisation((prev) => ({
                          ...prev,
                          [id]: value,
                        }));
                      }
                    }}
                  />
                </div>

                {/* Default Button */}
                <div className="col-2">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() =>
                      setOrganisation((prev) => ({
                        ...prev,
                        [id]: defaultValue,
                      }))
                    }
                  >
                    Default
                  </button>
                </div>
              </div>
            ))}

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>

          <hr style={{ color: "red" }} />

          {/* View AC */}
          <div className="row">
            <div className="col-12">
              <h5>View Action Cards</h5>
            </div>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center mt-2">
            <input
              type="checkbox"
              id="view_ac_online"
              checked={organisation.view_ac_online}
              onChange={onChangeHandler}
            />
            <label className="ms-2">View AC Online</label>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center mt-2">
            <input
              type="checkbox"
              id="view_employee_pdfs"
              checked={organisation.view_employee_pdfs}
              onChange={onChangeHandler}
            />
            <label className="ms-2">View Employee PDFs</label>
          </div>
          <div className="col-12 mb-3">{renderSectionUpdateButton()}</div>

          <hr style={{ color: "red" }} />

          {/* Section 2: Points Configuration */}
          <div className="row mb-4 align-items-start">
            <div className="col-md-5">
              <h5>Points Configuration</h5>

              <div className="mb-3">
                <label htmlFor="points_for_reading_ac" className="form-label">
                  Points for Reading 1 AC:
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="points_for_reading_ac"
                  value={organisation.points_for_reading_ac}
                  onChange={onChangeHandler}
                  min="0"
                />
              </div>

              <div className="mb-4">
                <label htmlFor="points_for_mt" className="form-label">
                  Points for 1 MT (Micro Training):
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="points_for_mt"
                  value={organisation.points_for_mt}
                  onChange={onChangeHandler}
                  min="0"
                />
              </div>
            </div>

            {/* Level Config */}
            <div className="col-md-3 ps-3">
              <h5>Level Config</h5>

              <div className="form-check mb-2 mt-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="platinumLevel"
                  checked={organisation.is_platinum}
                  onChange={(e) =>
                    setOrganisation((prev) => ({
                      ...prev,
                      is_platinum: e.target.checked,
                    }))
                  }
                />
                <label className="form-check-label" htmlFor="platinumLevel">
                  Platinum
                </label>
              </div>

              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="diamondLevel"
                  checked={organisation.is_diamond}
                  onChange={(e) =>
                    setOrganisation((prev) => ({
                      ...prev,
                      is_diamond: e.target.checked,
                    }))
                  }
                />
                <label className="form-check-label" htmlFor="diamondLevel">
                  Diamond
                </label>
              </div>
            </div>

            <div className="col-md-3 ps-3">
              <h5>Award Permissions</h5>

              {moduleOptions.map((module) => (
                <div className="col-md-10 mb-2" key={module}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`module-${module}`}
                      checked={selectedModules.includes(module)}
                      onChange={(e) => {
                        const updatedModules = e.target.checked
                          ? [...selectedModules, module]
                          : selectedModules.filter((m) => m !== module);
                        setSelectedModules(updatedModules);
                      }}
                    />
                    <label
                      className="form-check-label text-capitalize"
                      htmlFor={`module-${module}`}
                    >
                      {module.replace(/_/g, " ")}
                    </label>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>

          <hr style={{ color: "red" }} />
          {/* Section 3: Badge Ranges */}
          <div className="row gx-10">
            {/* Left Section */}
            <div className="col-md-6 mb-4">
              <h5>Badge Ranges</h5>
              <div className="row fw-bold mb-2">
                <div className="col-4">Badge Name</div>
                <div className="col-4">Min points</div>
                <div className="col-4">Max points</div>
              </div>

              {[
                ["no_badge", "No Badge"],
                ["bronze", "Bronze"],
                ["silver", "Silver"],
                ["gold", "Gold"],
                ["platinum", "Platinum"],
                ["diamond", "Diamond"],
              ].map(([prefix, label]) => (
                <div className="row mb-2 align-items-center" key={prefix}>
                  <div className="col-4">
                    <label className="form-label mb-0">{label}</label>
                  </div>
                  <div className="col-4">
                    <input
                      type="number"
                      className="form-control"
                      id={`${prefix}_min`}
                      value={organisation[`${prefix}_min`]}
                      onChange={onChangeHandler}
                      min="0"
                    />
                  </div>
                  <div className="col-4">
                    <input
                      type="number"
                      className="form-control"
                      id={`${prefix}_max`}
                      value={organisation[`${prefix}_max`]}
                      onChange={onChangeHandler}
                      placeholder={prefix === "diamond" ? "∞" : ""}
                      disabled={prefix === "diamond" ? true : false}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Right Section */}
            <div className="col-md-6 mb-4 pl-4">
              <h5>Max point for reading/day</h5>
              <div className="row fw-bold mb-2">
                <div className="col-4">Badge Name</div>
                <div className="col-4">Points Value</div>
              </div>

              {[
                ["bronze", "Bronze"],
                ["silver", "Silver"],
                ["gold", "Gold"],
                ["platinum", "Platinum"],
                ["diamond", "Diamond"],
              ].map(([prefix, label]) => (
                <div
                  className="row mb-2 align-items-center"
                  key={`right-${prefix}`}
                >
                  <div className="col-4">
                    <label className="form-label mb-0">{label}</label>
                  </div>
                  <div className="col-4">
                    <input
                      type="number"
                      className="form-control"
                      id={`${prefix}_reading_max`}
                      value={organisation[`${prefix}_reading_max`]}
                      onChange={onChangeHandler}
                      min="0"
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>
          <hr style={{ color: "red" }} />
          {/* Section 4: Badge Ranges */}
          <div className="row gx-10">
            {/* Left Section */}
            <div className="col-md-6 mb-4">
              <h5>Minimum requirement for at least 1 MT</h5>
              <div className="row fw-bold mb-2">
                <div className="col-4">Badge Name</div>
                <div className="col-4">Less than month(s)</div>
              </div>

              {[
                ["bronze", "Bronze"],
                ["silver", "Silver"],
                ["gold", "Gold"],
                ["platinum", "Platinum"],
                ["diamond", "Diamond"],
              ].map(([prefix, label]) => (
                <div className="row mb-2 align-items-center" key={prefix}>
                  <div className="col-4">
                    <label className="form-label mb-0">{label}</label>
                  </div>
                  <div className="col-4">
                    <input
                      type="number"
                      className="form-control"
                      id={`${prefix}_min_for_mt`}
                      value={organisation[`${prefix}_min_for_mt`]}
                      onChange={onChangeHandler}
                      min="0"
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Right Section */}
            <div className="col-md-6 mb-4 pl-4">
              <h5>Point Decrease</h5>
              <div className="row fw-bold mb-2"></div>

              {/* Date Picker */}
              <div className="row mb-2 align-items-center">
                <div className="col-4">
                  <label htmlFor="selectedDate" className="form-label mb-0">
                    Start Date
                  </label>
                </div>
                <div className="col-4">
                  <input
                    type="date"
                    id="selectedDate"
                    className="form-control"
                    value={organisation.selectedDate}
                    onChange={onChangeHandler}
                  />
                </div>
              </div>
              {/* Inputs Section */}
              {[
                ["decrease_per_week", "Decrease (%)", "pct"],
                [
                  "length_decease_period",
                  "Length of decrease period (days)",
                  "days",
                ],
                [
                  "decease_ptc_due_to_inactivity",
                  "Decrease due to inactivity (%)",
                  "pct",
                ],
                [
                  "length_inactivity_periode",
                  "Length of inactivity period (days)",
                  "days",
                ],
                [
                  "decrease_in_pct_if_mt_requirements_not_met",
                  "Decrease if MT requirements aren't met (%)",
                  "pct",
                ],
                ["evaluation_time", "Evaluation Time (days)", "days"],
              ].map(([prefix, label, postfix]) => (
                <div
                  className="row mb-2 align-items-center"
                  key={`right-${prefix}`}
                >
                  <div className="col-4">
                    <label className="form-label mb-0">{label}</label>
                  </div>
                  <div className="col-4">
                    <input
                      type="number"
                      className="form-control"
                      id={`${prefix}`}
                      value={organisation[`${prefix}`]}
                      onChange={onChangeHandler}
                      min="0"
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label mb-0">{postfix}</label>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>
          <hr style={{ color: "red" }} />

          {/* Section 5: Educational Videos (fixed - uses correct keys & states) */}
          <div className="row">
            <h5>Educational Videos</h5>
            <div className="col-12">
              <div>
                <label className="" htmlFor="showVideo">
                  Show Educational Video and Quiz
                </label>
                <input
                  type="checkbox"
                  className="ml-2"
                  checked={organisation.view_educational_videos}
                  onChange={handleCheckboxChange}
                />
              </div>
            </div>

            {showVideoConfig && (
              <div className="col-12">
                <div className="row">
                  {/* Dropdown */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Select Videos</label>
                    <VideoListDropdown
                      options={videoOptions}
                      defaultValues={defaultVideoIds}
                      onChange={handleSelectedIds}
                    />
                  </div>

                  {/* Inputs */}
                  <div className="col-md-6">
                    {/* Delay */}
                    <div className="row mb-2 align-items-center">
                      <label className="col-5 col-form-label">
                        Delay (hrs)
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="delay_videos_quiz"
                          value={organisation.delay_videos_quiz}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>

                    {/* Questions */}
                    <div className="row mb-2 align-items-center">
                      <label className="col-5 col-form-label">
                        No. of Questions per Video
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="videos_questions_per_quiz"
                          value={organisation.videos_questions_per_quiz}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>

                    {/* Expire */}
                    <div className="row mb-2 align-items-center">
                      <label className="col-5 col-form-label">
                        Expire (Days)
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="expire_videos_quiz"
                          value={organisation.expire_videos_quiz}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>

                    {/* Points */}
                    <div className="row mb-2 align-items-center">
                      <label className="col-5 col-form-label">
                        Points for Award
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="videos_points_awarded"
                          value={organisation.videos_points_awarded}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>

          <hr style={{ color: "red" }} />

          {/* Section 6: Read Action cards (fixed - separate checkbox, state, correct keys) */}
          <div className="row">
            <h5>Read Action cards</h5>
            <div className="col-12">
              <div>
                <label className="" htmlFor="showCards">
                  Read Action card Quiz
                </label>
                <input
                  type="checkbox"
                  className="ml-2"
                  checked={organisation.view_cards_quiz}
                  onChange={handleCardsCheckboxChange}
                />
              </div>
            </div>

            {showCardsConfig && (
              <div className="col-12">
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label>Delay (hrs)</label>
                    <input
                      type="number"
                      className="form-control"
                      id="delay_cards_quiz"
                      value={organisation.delay_cards_quiz}
                      onChange={onChangeHandler}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>No. of Questions per Quiz</label>
                    <input
                      type="number"
                      className="form-control"
                      id="cards_questions_per_quiz"
                      value={organisation.cards_questions_per_quiz}
                      onChange={onChangeHandler}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Expire (Days)</label>
                    <input
                      type="number"
                      className="form-control"
                      id="expire_cards_quiz"
                      value={organisation.expire_cards_quiz}
                      onChange={onChangeHandler}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Points for Award</label>
                    <input
                      type="number"
                      className="form-control"
                      id="cards_points_awarded"
                      value={organisation.cards_points_awarded}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>
          <hr style={{ color: "red" }} />

          {/* Section 7: Only Quiz (fixed - correct dropdown, keys, separate handler) */}
          <div className="row">
            <h5>Only Quiz </h5>

            <div className="col-12">
              <div>
                <label className="" htmlFor="showCards">
                  Only Quizzes Quiz
                </label>
                <input
                  type="checkbox"
                  className="ml-2"
                  checked={organisation.view_quiz}
                  onChange={handleQuizCheckboxChange}
                />
              </div>
            </div>
            {showQuizConfig && (
              <div className="col-12">
                <div className="row">
                  {/* Left Side - Dropdown */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Select Quiz</label>
                    <OnlyQuizListDropdown
                      options={quizzesOptions}
                      defaultValues={defaultQuestionIds}
                      onChange={handleQuizSelectedIds}
                    />
                  </div>

                  <div className="col-md-6">
                    {/* Points for Award */}
                    <div className="row align-items-center mb-2">
                      <label className="col-5 col-form-label">
                        Points for Award
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="quiz_points_awarded"
                          value={organisation.quiz_points_awarded}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>

                    {/* No. of Questions per Video */}
                    <div className="row align-items-center mb-2">
                      <label className="col-5 col-form-label">
                        No. of Questions per Quiz
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="questions_per_quiz"
                          value={organisation.questions_per_quiz}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="row align-items-center">
                      <label className="col-5 col-form-label">
                        Reappear after hours
                      </label>
                      <div className="col-7">
                        <input
                          type="number"
                          className="form-control"
                          id="reappear_after_hours"
                          value={organisation.reappear_after_hours}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-12">{renderSectionUpdateButton()}</div>
          </div>

          <hr style={{ color: "red" }} />

          {/* Submit Button */}
          <div className="row mt-4">
            <div className="col-12 text-center">
              <button
                type="submit"
                className="btn btn-primary bg_color px-5 mb-3"
              >
                {paramIdSeprator(search) ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddOrganisation;
